import React from "react";
import { useNavigate } from "react-router-dom";
import { Element } from "react-scroll";
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
import AuthDispatcher from "../redux/dispatch/AuthDispatcher";

export default function MainLayout({ children }) {
  const navigate = useNavigate();

  const handleLogout = () => {
    AuthDispatcher.logout();
    navigate("/");
  };

  return (
    <React.Fragment>
      <Element name="NavBar">
        <NavBar handleLogout={handleLogout} />
        <div
          className="my-5 pt-5"
          style={{ marginLeft: "8%", marginRight: "8%", minHeight: "49.1vh" }}
        >
          {children}
        </div>
        <Footer />
      </Element>
    </React.Fragment>
  );
}
